import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=154cf2ce&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=154cf2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cf2ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154cf2ce')) {
      api.createRecord('154cf2ce', component.options)
    } else {
      api.reload('154cf2ce', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=154cf2ce&scoped=true&", function () {
      api.rerender('154cf2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ash9XZ3QUqes/JS/comp/GuestBox.vue"
export default component.exports